import {SelectPromotionHandleClick, ViewPromotionHandleView} from 'helpers-ga4';

if (!customElements.get('copy-button')) {
  class CopyButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.ariaLiveRegion = this.querySelector(
        '.card-hero__promo-panel-a11y-msg',
      );

      if (this.button) {
        this.textToCopy = this.button
          .querySelector('.card-hero__promo-panel-copy-btn-coupon-code-text')
          ?.textContent?.trim();

        if (!this.button.hasAttribute('aria-label')) {
          this.button.setAttribute(
            'aria-label',
            `Copy coupon code: ${this.textToCopy}`,
          );
        }

        this.button.addEventListener('click', this.handleCopy.bind(this));
        this.button.addEventListener('click', (event) => {
          if (this.button.dataset.ga4PromotionName?.trim()) {
            SelectPromotionHandleClick(event);
          }
        });

        const viewPromotionObserver = new IntersectionObserver(
          (entries, obs) => {
            if (entries[0].isIntersecting) {
              ViewPromotionHandleView(this.button);
              obs.disconnect();
            }
          },
          {threshold: 0.5},
        );
        viewPromotionObserver.observe(this);
      }
    }

    handleCopy() {
      const copiedMessage =
        this.button
          .querySelector('.card-hero__promo-panel-copy-btn-copied-text')
          ?.textContent?.trim() || 'Copied!';

      if (!this.textToCopy) return;

      navigator.clipboard
        .writeText(this.textToCopy)
        .then(() => {
          this.button.classList.add('card-hero__promo-panel-copy-btn-copied');
          this.button.setAttribute(
            'aria-label',
            `${copiedMessage} ${this.textToCopy}`,
          );
          this.ariaLiveRegion.textContent = `${copiedMessage} ${this.textToCopy}`;

          setTimeout(() => {
            this.button.classList.remove(
              'card-hero__promo-panel-copy-btn-copied',
            );
            this.button.setAttribute(
              'aria-label',
              `Copy coupon code: ${this.textToCopy}`,
            );
            this.ariaLiveRegion.textContent = '';
          }, 5000);
        })
        .catch((err) => {
          console.error('Failed to copy text:', err);
          this.ariaLiveRegion.textContent = 'Failed to copy coupon code';
          this.button.setAttribute(
            'aria-label',
            'Failed to copy, please try again',
          );
        });
    }
  }

  customElements.define('copy-button', CopyButton);
}
